__turbopack_context__.v({
  "className": "pixelify_sans_aa7d00e0-module__YxRD4q__className",
});
